import React from "react";
import { Container, Row, Col, Nav, Navbar, Table } from "react-bootstrap";
import ContentBlock from "../Components/ContentBlock";
import TopNavBar from "../Components/TopNavBar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { isLoggedIn, clearUser,setUser  } from "../Session/Session";
import OrdersService from "../Api/OrdersService";
import LoginService from "../Api/LoginService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class AccountPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageName: 'Mano paskyra',
            activeSecondaryRoute: 1,
            uzsakymai: [],
        }

        this.logout = this.logout.bind(this);
        this.getUzsakymai = this.getUzsakymai.bind(this);
        this.openUzsakymai = this.openUzsakymai.bind(this);
        this.openPaskyrosNustatymai = this.openPaskyrosNustatymai.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
    }

    checkLoginStatus() {
        if (!isLoggedIn()) {
            window.location.href = '/login';
        }
    }

    componentDidMount() {
        this.checkLoginStatus();
        this.getUserInfo();
        this.getUzsakymai();
    }

    getUserInfo() {
        LoginService.getUserInfo()
            .then(response => {
                setUser(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    getUzsakymai() {
        OrdersService.getOrders()
            .then(response => {
                this.setState({
                    uzsakymai: response.data,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    openUzsakymai() {
        this.setState({
            activeSecondaryRoute: 1,
        });
    }

    openPaskyrosNustatymai() {
        this.setState({
            activeSecondaryRoute: 2,
        });
    }

    logout() {
        clearUser();
        localStorage.removeItem('token');
        window.location.href = '/login';
    }


    render() {
        const myStyle = {
            backgroundImage: "url(/main-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };

        const uzsakymaiTableStyle = {
            width: '100%',
            color: 'white',
        };

        return (
            <Container fluid style={myStyle}>
                <TopNavBar activeRoute={3} />
                <Container>
                    <h1 className='page-title'>{this.state.pageName}</h1>
                    <ContentBlock>
                        <Row>
                            <Navbar variant="dark" expand="lg" sticky="top">
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="mr-auto">
                                        <Nav.Link href="#link" active={this.state.activeSecondaryRoute === 1} onClick={this.openUzsakymai}>Užsakymai</Nav.Link>
                                        <Nav.Link href="#link" active={this.state.activeSecondaryRoute === 2} onClick={this.openPaskyrosNustatymai}>Paskyros nustatymai</Nav.Link>
                                        <Nav.Link href="#link" onClick={this.logout}>Atsijungti</Nav.Link>
                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                        </Row>
                        <Row>
                            <Container fluid id='uzsakymai' hidden={this.state.activeSecondaryRoute === 2}>
                                <div style={{marginTop: '50px'}}>
                                    <Table bordered style={uzsakymaiTableStyle}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Užsakymo data</th>
                                                <th>Užsakymo statusas</th>
                                                <th>Užsakymo suma</th>
                                                <th>Užsakymo detalės</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.uzsakymai.map((uzsakymas, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{uzsakymas.uzsakymoData}</td>
                                                        <td>{uzsakymas.uzsakymoStatusas}</td>
                                                        <td>{uzsakymas.uzsakymoSuma}</td>
                                                        <td>
                                                            <Link to={{
                                                                pathname: '/uzsakymo-detales',
                                                                state: {
                                                                    uzsakymoId: uzsakymas.uzsakymoId,
                                                                    uzsakymoData: uzsakymas.uzsakymoData,
                                                                    uzsakymoStatusas: uzsakymas.uzsakymoStatusas,
                                                                    uzsakymoSuma: uzsakymas.uzsakymoSuma,
                                                                    uzsakymoPrekes: uzsakymas.uzsakymoPrekes
                                                                }
                                                            }}>Peržiūrėti</Link>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </Container>
                            <Container fluid id='nustatymai'  hidden={this.state.activeSecondaryRoute === 1}>
                                    <div>
                                        <h1>Paskyros nustatymai</h1>

                                    </div>
                            </Container>
                        </Row>
                    </ContentBlock>
                </Container>
                <Footer></Footer>
            </Container>
        );

    }
}

export default AccountPage;
